import React, { useState } from "react";
import { InlineTextEdit } from "./InlineTextEdit";
import { StoryNode } from "../StoryBook/StoryData";

export const InlineTextEditSelectStories = [
    new StoryNode(
        () => {
            const [_value, setValue] = useState("");
            return (
                <InlineTextEdit
                    text={""}
                    onEdit={(newValue) => {
                        setValue(newValue);
                    }}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Inline Text Edit",
        "Default"
    ),
    new StoryNode(
        () => {
            const [_value, setValue] = useState("Label");
            return (
                <InlineTextEdit
                    text={"Label"}
                    onEdit={(newValue) => {
                        setValue(newValue);
                    }}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Inline Text Edit",
        "With Text"
    ),
];
